export default __webpack_public_path__ + "static/media/tossBall.3534c393.mp3";